
import Vue from 'vue'
import AttendanceTransformer from '@/transformers/workPlan/attendance'
import errorHandler from '@/utils/errorHandler'

export default (workPlanAssistance) => {
	const payload = AttendanceTransformer.send(workPlanAssistance)
	return errorHandler(Vue.$http.post('workplan/assistence/', payload))
		.then(response => response.data)
}


// WEBPACK FOOTER //
// ./src/services/workPlan/sendAssistance.js